import ServiceDetailPage from "./ServiceDetailPage";
import serviceContent from "./serviceContent";

const WebAppDevelopment = () => <ServiceDetailPage service={serviceContent.development} />;

export default WebAppDevelopment;
